module.exports = __webpack_public_path__ + "static/media/Cecelia.cbd0442f.png";